import React, { useState } from "react";
import { ChromePicker } from "react-color";
import { useDispatch } from "react-redux";
import "./ColorEditor.scss";

// https://casesandberg.github.io/react-color/
const ColorEditor = React.memo((props) => {
  const [color, setColor] = useState(`#${props.value.toString(16)}`);
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  return (
    <div className="ColorEditor">
      <div className="ColorEditor_swatch" onClick={(e) => setOpen(!open)}>
        {open && (
          <div className="ColorEditor_cover" onClick={(e) => setOpen(false)} />
        )}
        <div className="ColorEditor_color" style={{ backgroundColor: color }} />
      </div>
      <label>{props.label}</label>

      {open && (
        <div className="ColorEditor_popover">
          <ChromePicker
            color={color}
            onChange={e => setColor(e.hex)}
            onChangeComplete={(e) => {
              const value = (e.rgb.r << 16) + (e.rgb.g << 8) + e.rgb.b; /*  */
              dispatch({
                ...props.action,
                payload: {
                  ...props.action.payload,
                  value,
                },
              });
            }}
          />
        </div>
      )}
    </div>
  );
});

export default ColorEditor;
